module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    on: {
      "click": _vm.hideImage
    }
  }, [_c('div', {
    staticClass: "see-image",
    style: ({
      backgroundColor: _vm.background
    })
  }, [(_vm.isImage) ? _c('img', {
    directives: [{
      name: "drag",
      rawName: "v-drag",
      value: (_vm.greet),
      expression: "greet"
    }],
    ref: "user_image",
    staticClass: "image",
    attrs: {
      "id": "drag",
      "src": _vm.currentImg
    },
    on: {
      "wheel": function($event) {
        $event.preventDefault();
        return _vm.wheel($event)
      }
    }
  }) : _c('video', {
    ref: "user_video",
    staticClass: "image",
    staticStyle: {
      "width": "100%",
      "height": "60%"
    },
    attrs: {
      "id": "drag",
      "src": _vm.currentImg,
      "controls": "",
      "autoplay": ""
    }
  }, [_vm._v("\n            您的浏览器不支持视频标签\n        ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.closeButtonVisible),
      expression: "closeButtonVisible"
    }],
    staticClass: "close"
  }, [_c('Icon', {
    staticClass: "close-icon",
    attrs: {
      "type": "close-circled",
      "size": 40
    },
    on: {
      "click": _vm.close
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.controlButtonVisible),
      expression: "controlButtonVisible"
    }],
    staticClass: "control"
  }, [_c('Icon', {
    staticClass: "control-icon",
    attrs: {
      "type": "ios-arrow-back",
      "size": 24
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prevImage($event)
      }
    }
  }), _vm._v(" "), (_vm.isImage) ? _c('Icon', {
    staticClass: "control-icon",
    attrs: {
      "type": "android-add-circle",
      "size": 24
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.scaleImage('add')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isImage) ? _c('Icon', {
    staticClass: "control-icon",
    attrs: {
      "type": "android-remove-circle",
      "size": 24
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.scaleImage('remove')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isImage) ? _c('Icon', {
    staticClass: "control-icon",
    attrs: {
      "type": "reply",
      "size": 24
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.rotateImage('left')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isImage) ? _c('Icon', {
    staticClass: "control-icon",
    attrs: {
      "type": "forward",
      "size": 24
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.rotateImage('right')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('Icon', {
    staticClass: "control-icon",
    attrs: {
      "type": "ios-arrow-forward",
      "size": 24
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.nextImage($event)
      }
    }
  })], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5daa9619","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/util/vue-imageViewer-master/ImageViewer.vue
// module id = 1036
// module chunks = 14